/**
 * Image Editor
 * Handles configuration for image display controls
 */

import React from 'react';
import type { PropertyEditor, PropertyEditorProps } from '../../../registry/PropertyEditor.types';

/**
 * Render function for image control
 */
function renderImageEditor(props: PropertyEditorProps) {
  const { control, onConfigChange } = props;

  return (
    <div className="af-properties-tab__section">
      <h4 className="af-properties-tab__subsection-title">Control Configuration</h4>
      <div className="af-properties-tab__group">
        <label className="af-properties-tab__label">
          Image URL
          <input
            type="text"
            value={(control.config?.src as string) || ''}
            onChange={(e) => onConfigChange('src', e.target.value || undefined)}
            className="af-properties-tab__input"
            placeholder="https://..."
          />
        </label>
      </div>
      <div className="af-properties-tab__group">
        <label className="af-properties-tab__label">
          Alt Text
          <input
            type="text"
            value={(control.config?.alt as string) || ''}
            onChange={(e) => onConfigChange('alt', e.target.value)}
            className="af-properties-tab__input"
            placeholder="Describe the image"
          />
        </label>
      </div>
      <div className="af-properties-tab__group">
        <label className="af-properties-tab__label">
          Width
          <input
            type="text"
            value={(control.config?.width as string) || ''}
            onChange={(e) => onConfigChange('width', e.target.value || 'auto')}
            className="af-properties-tab__input"
            placeholder="auto / 100% / 300px"
          />
        </label>
      </div>
      <div className="af-properties-tab__group">
        <label className="af-properties-tab__label">
          Height
          <input
            type="text"
            value={(control.config?.height as string) || ''}
            onChange={(e) => onConfigChange('height', e.target.value || 'auto')}
            className="af-properties-tab__input"
            placeholder="auto / 200px"
          />
        </label>
      </div>
      <div className="af-properties-tab__group">
        <label className="af-properties-tab__label">
          Max Width
          <input
            type="text"
            value={(control.config?.maxWidth as string) || '100%'}
            onChange={(e) => onConfigChange('maxWidth', e.target.value || '100%')}
            className="af-properties-tab__input"
            placeholder="100%"
          />
        </label>
      </div>
      <div className="af-properties-tab__group">
        <label className="af-properties-tab__label">
          Object Fit
          <select
            value={(control.config?.objectFit as string) || 'contain'}
            onChange={(e) => onConfigChange('objectFit', e.target.value)}
            className="af-properties-tab__select"
          >
            <option value="contain">Contain</option>
            <option value="cover">Cover</option>
            <option value="fill">Fill</option>
            <option value="none">None</option>
            <option value="scale-down">Scale Down</option>
          </select>
        </label>
      </div>
    </div>
  );
}

/**
 * ImageEditor - Handles image control configuration
 */
export const ImageEditor: PropertyEditor = {
  type: 'image',
  label: 'Image',
  description: 'Configure image URL, sizing, and display properties',
  render: renderImageEditor,
};
